<template>
  <div class="content-wrapper">
    <sub-header :title="$t('menu.cashhero')" />
    <section class="content container-fluid">
      <router-view />
    </section>
  </div>
</template>

<script>
import SubHeader from '@/components/SubHeader'

export default {
  name: 'Referral',
  components: { SubHeader }
}
</script>

<style scoped>

</style>
